// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__asjg9","buttons":"RemoveExpirationActionButtons_buttons__2HUQj"};